import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const CasesHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mb: { xs: 2, md: 3 },
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Typography variant="h4">Cases</Typography>
      <Button
        variant="contained"
        startIcon={<Plus />}
        onClick={() => navigate('/case-intake')}
      >
        New Case
      </Button>
    </Box>
  );
};